import React, { useEffect, useState } from "react";
import { Container, Card, Button, Spinner, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getoptions, calculatePackageOption } from "../../store/slices/package";
import { toast } from "react-toastify";

export default function PricingStep({ packageId, prevStep }) {
  const dispatch = useDispatch();

  const [options, setOptions] = useState([]);
  const [pricingData, setPricingData] = useState({});
  const [loading, setLoading] = useState(false);

  // 🔥 Fetch Options
  useEffect(() => {
    if (!packageId) return;

    const fetchOptions = async () => {
      try {
        const res = await dispatch(getoptions({ packageId })).unwrap();
        setOptions(res?.data || []);
      } catch (err) {
        toast.error("Failed to load options");
      }
    };

    fetchOptions();
  }, [packageId, dispatch]);

  // 🔥 Calculate Pricing
  const handleCalculate = async () => {
    if (!options.length) {
      toast.error("No options found");
      return;
    }

    setLoading(true);

    try {
      const results = {};

      for (const opt of options) {
        const priceRes = await dispatch(
          calculatePackageOption({ optionId: opt._id }),
        ).unwrap();

        results[opt._id] = priceRes?.breakup; //  store breakup
      }

      setPricingData(results);
      toast.success("Pricing recalculated successfully");
    } catch (err) {
      toast.error("Failed to calculate pricing");
    }

    setLoading(false);
  };

  return (
    <Container>
      <Card className="p-4 shadow-sm border-0">
        <h4 className="mb-4">Package Pricing</h4>

        <Button
          onClick={handleCalculate}
          disabled={loading}
          style={{ background: "#1E0959", border: "none" }}
        >
          {loading ? <Spinner size="sm" /> : "Recalculate Pricing"}
        </Button>

        <div className="mt-4">
          {options.map((opt) => {
            const data = pricingData[opt._id];

            return (
              <Card key={opt._id} className="mb-4 p-4 shadow-sm border">
                <h5 className="mb-3">{opt.name}</h5>

                {data ? (
                  <>
                    <Row>
                      <Col md={6}>
                        <p>
                          <strong>Hotel Cost:</strong> ₹{data.hotelCost}
                        </p>
                        <p>
                          <strong>Activity Cost:</strong> ₹{data.activityCost}
                        </p>
                        <p>
                          <strong>Ferry Cost:</strong> ₹{data.ferryCost}
                        </p>
                        <p>
                          <strong>Vehicle Cost:</strong> ₹{data.vehicleCost}
                        </p>
                      </Col>

                      <Col md={6}>
                        <p>
                          <strong>Total Base Cost:</strong> ₹
                          {data.totalBaseCost}
                        </p>
                        <p>
                          <strong>Cost Per Person:</strong> ₹
                          {data.costPerPerson}
                        </p>
                        <p>
                          <strong>Markup Per Person:</strong> ₹{data.markupAmount}
                        </p>
                        <p>
                          <strong>GST Per Person:</strong> ₹{data.gstAmount}
                        </p>
                      </Col>
                    </Row>

                    <hr />

                    <div
                      style={{
                        background: "#F4C430",
                        padding: "12px",
                        borderRadius: "8px",
                        fontSize: "18px",
                        fontWeight: "600",
                      }}
                    >
                      Selling Price Per Person: ₹{data.sellingPricePerPerson}
                    </div>
                  </>
                ) : (
                  <p className="text-muted">
                    Click recalculation to view pricing
                  </p>
                )}
              </Card>
            );
          })}
        </div>

        <div className="mt-4">
          <button className="cancel-btn" onClick={prevStep}>
            Back
          </button>
        </div>
      </Card>
    </Container>
  );
}